import { map, prop } from 'ramda'
import React from 'react'

import CheckboxesList from '../form/CheckboxesList'
import FilterSideModal from './FilterSideModal'

const defaultRenderValue = (values, options) => {
  if (!values) return values
  if (values.length > 5 || values.some(item => !item.label)) {
    return `${values.length} selecionados`
  }
  const formattedSelectedValues = map(prop('label'), values) || []

  return formattedSelectedValues.join(', ')
}

const defaultRenderOptions = (options, values, setValue) => {
  return <CheckboxesList value={values} onChange={setValue} options={options || []} />
}

const CheckboxesFilterSideModal = ({ renderValue, renderOptions, ...props }) => {
  renderValue = renderValue || defaultRenderValue
  renderOptions = renderOptions || defaultRenderOptions

  return <FilterSideModal renderOptions={renderOptions} renderValue={renderValue} useLoader {...props} />
}

export default CheckboxesFilterSideModal
